import { cn } from '@/lib/utils'

type BadgeVariant = 'default' | 'amber' | 'new' | 'bestseller' | 'limited' | 'refillable'

interface BadgeProps {
  children: React.ReactNode
  variant?: BadgeVariant
  className?: string
}

const variants: Record<BadgeVariant, string> = {
  default: 'border border-line text-carbon/70',
  amber: 'bg-wd-orange text-paper',
  new: 'border border-wd-orange/70 text-carbon',
  bestseller: 'bg-ink text-paper',
  limited: 'border border-wd-red text-carbon',
  refillable: 'border border-charcoal text-carbon',
}

export function Badge({ children, variant = 'default', className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-sm px-2.5 py-1 text-xs uppercase tracking-[0.15em]',
        variants[variant],
        className
      )}
    >
      {children}
    </span>
  )
}
